/* eslint-disable react/forbid-dom-props */
import LoadingShape from 'components/LoadingShape';
import { BusinessHealthScore } from '../../types';
import {
    HealthMetricValueLine,
    IndicatorContainer,
    StyledBadge,
    ValueContainer,
} from '../styled';
import formatMetricValue from '../../helpers/formatMetricValue';
import getLabelForStatus from '../../helpers/getLabelForStatus';
import getBadgeVariantForHealthStatus from '../helpers/getBadgeVariantForHealthStatus';
import HealthIndicatorLegend from './chart';

interface BusinessHealthIndicatorProps {
    isLoading?: boolean;
    data?: BusinessHealthScore;
}

const BusinessHealthIndicator = ({
    isLoading, data,
}: BusinessHealthIndicatorProps) => {
    if (isLoading) {
        return (
            <LoadingShape shape="rounded-rect" width="160px" height="140px" />
        );
    }

    const { value = 0, status } = data || {};

    return (
        <IndicatorContainer>
            <HealthIndicatorLegend score={value} />
            <ValueContainer>
                <HealthMetricValueLine>
                    {formatMetricValue(value, 'score')}
                </HealthMetricValueLine>
                <StyledBadge
                    label={getLabelForStatus(status)}
                    variant={getBadgeVariantForHealthStatus(status)}
                />
            </ValueContainer>
        </IndicatorContainer>
    );
};

export default BusinessHealthIndicator;
